export default __webpack_public_path__ + "static/media/cruelty-free.7b95109b.svg";